<mat-toolbar class="sub-toolbar">Account</mat-toolbar>

<div *ngIf="loading" class="loading-container">
	<mat-spinner></mat-spinner>
</div>

<div *ngIf="!loading" class="account-container">

	<mat-tab-group>

		<!-- Tab 1: Profile Info -->
		<mat-tab label="Profile">
			<div class="tab-content">
				<h3>Profile Information</h3>
				<form [formGroup]="profile_form" (ngSubmit)="save_profile()">
					<mat-form-field class="full-width">
						<mat-icon matPrefix>person</mat-icon>
						<input matInput formControlName="name" placeholder="Display Name">
						<mat-error>{{get_error(profile_form, 'name')}}</mat-error>
					</mat-form-field>
					<mat-form-field class="full-width">
						<mat-icon matPrefix>email</mat-icon>
						<input matInput formControlName="email" placeholder="Email" type="email">
						<mat-error>{{get_error(profile_form, 'email')}}</mat-error>
					</mat-form-field>
					<div class="form-actions">
						<button mat-raised-button color="primary" type="submit" [disabled]="profile_form.invalid || profile_saving">
							<mat-spinner *ngIf="profile_saving" diameter="20"></mat-spinner>
							<span *ngIf="!profile_saving">Save Profile</span>
						</button>
					</div>
				</form>
			</div>
		</mat-tab>

		<!-- Tab 2: Change Password -->
		<mat-tab label="Password">
			<div class="tab-content">
				<h3>Change Password</h3>
				<form [formGroup]="password_form" (ngSubmit)="change_password()">
					<mat-form-field class="full-width">
						<mat-icon matPrefix>lock</mat-icon>
						<input matInput formControlName="current_password" placeholder="Current Password" type="password">
						<mat-error>{{get_error(password_form, 'current_password')}}</mat-error>
					</mat-form-field>
					<mat-form-field class="full-width">
						<mat-icon matPrefix>lock_open</mat-icon>
						<input matInput formControlName="new_password" placeholder="New Password" type="password">
						<mat-error>{{get_error(password_form, 'new_password')}}</mat-error>
					</mat-form-field>
					<mat-form-field class="full-width">
						<mat-icon matPrefix>lock_open</mat-icon>
						<input matInput formControlName="confirm_password" placeholder="Confirm New Password" type="password">
						<mat-error *ngIf="password_form.errors?.passwords_mismatch && password_form.get('confirm_password').touched">
							Passwords do not match.
						</mat-error>
					</mat-form-field>
					<div class="form-actions">
						<button mat-raised-button color="primary" type="submit" [disabled]="password_form.invalid || password_saving">
							<mat-spinner *ngIf="password_saving" diameter="20"></mat-spinner>
							<span *ngIf="!password_saving">Change Password</span>
						</button>
					</div>
				</form>
			</div>
		</mat-tab>

		<!-- Tab 3: App Preferences -->
		<mat-tab label="Preferences">
			<div class="tab-content">
				<h3>App Preferences</h3>
				<mat-list>
					<mat-list-item *ngFor="let name of s.keys(s.settings)" [ngSwitch]="s.settings[name].type">
						<mat-form-field *ngSwitchCase="'select'" class="full-width">
							<mat-select
								[placeholder]="s.settings[name].label"
								[ngModel]="s.settings[name].value"
								(ngModelChange)="s.changed($event, name)">
								<mat-option
									*ngFor="let value of s.keys(s.settings[name].options)"
									[value]="value">
									{{s.settings[name].options[value]}}
								</mat-option>
							</mat-select>
						</mat-form-field>
						<ng-container *ngSwitchCase="'button'">
							<button mat-raised-button color="accent" (click)="s.button_clicked($event, name)">
								{{s.settings[name].label}}
							</button>
						</ng-container>
					</mat-list-item>
				</mat-list>
			</div>
		</mat-tab>

		<!-- Tab 4: Managed Communities (owners only) -->
		<mat-tab label="My Communities" *ngIf="user_role === 'owner'">
			<div class="tab-content">
				<h3>Managed Communities</h3>
				<div *ngIf="managed_communities.length === 0" class="empty-state">
					<mat-icon>business</mat-icon>
					<p>No communities are associated with your account.</p>
				</div>
				<mat-list *ngIf="managed_communities.length > 0">
					<mat-list-item *ngFor="let community of managed_communities" class="community-list-item">
						<mat-icon matListAvatar>business</mat-icon>
						<h3 matLine>{{community.name}}</h3>
						<p matLine *ngIf="community.address">{{community.address.city}}, {{community.address.state}}</p>
						<button mat-icon-button color="primary" (click)="go_to_community(community.id)" matTooltip="View listing">
							<mat-icon>visibility</mat-icon>
						</button>
					</mat-list-item>
				</mat-list>
			</div>
		</mat-tab>

	</mat-tab-group>

	<div class="sign-out-section">
		<button mat-stroked-button color="warn" (click)="sign_out()">
			<mat-icon>exit_to_app</mat-icon>
			Sign Out
		</button>
	</div>

</div>
